import type { ApiState } from '../../api/useApiData';
import { ApiRequestError } from '../../api/client';

/* Consistent loading/error/empty/ready rendering (task requirement #13)
 * for any section backed by an API call — every page below uses this
 * instead of a one-off spinner or a silently blank section. */
export default function AsyncSection<T>({
  state,
  render,
  emptyMessage = 'Nothing published here yet.',
}: {
  state: ApiState<T>;
  render: (data: T) => React.ReactNode;
  emptyMessage?: string;
}) {
  if (state.status === 'loading') {
    return (
      <div className="card reveal is-visible" role="status" aria-live="polite">
        <p className="body-sm">Loading…</p>
      </div>
    );
  }
  if (state.status === 'error') {
    const notFound = state.error instanceof ApiRequestError && state.error.status === 404;
    return (
      <div className="card reveal is-visible">
        <p className="body-sm">{notFound ? "This page isn't available yet." : `Something went wrong loading this: ${state.error.message}`}</p>
      </div>
    );
  }
  if (state.status === 'empty') {
    return (
      <div className="card reveal is-visible">
        <p className="body-sm">{emptyMessage}</p>
      </div>
    );
  }
  return <>{render(state.data)}</>;
}
